import useSWR from 'swr';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AppContext } from 'providers/AppProvider';
import { buildNetbankPayload, getNetbankFormErrors, getNetbankFormValues, validators } from './NetbankHelpers';

export function useNetbank() {
	const ctx = useContext(AppContext);
	const { config, goToNextPage, http, navigate, state, t } = ctx;
	const { context, user } = state;
	const { kennitala, processInfo } = context;
	const { agreementProcessId } = processInfo;
	const [applicantIsOnlyUser, setApplicantIsOnlyUser] = useState(true);
	const [errors, setErrors] = useState({} as any);
	const { data } = useSWR(`${config.API.hasOnlineBankingAccount}?ssn=${kennitala}`);

	const validate = useCallback(
		(e: any) => {
			e.preventDefault();
			e.stopPropagation();
			const newErrors = (validators as any)[e.target.name](e.target.value);
			const oldErrors = { ...errors };
			delete oldErrors[e.target.name];
			setErrors({ ...oldErrors, ...newErrors });
		},
		[errors]
	);

	const submitForm = useCallback(
		(e: any) => {
			e.preventDefault();
			e.stopPropagation();
			if (applicantIsOnlyUser) {
				goToNextPage();
			} else {
				const values = getNetbankFormValues(applicantIsOnlyUser);
				const newErrors = getNetbankFormErrors(values);
				setErrors(newErrors);
				if (!Object.keys(newErrors).length) {
					const msg = t('submit_label', 'netbank');
					const payload = buildNetbankPayload(values, user.kennitala);
					http.post(`${config.API.netbank}/${agreementProcessId}`, payload, msg).then(goToNextPage);
				}
			}
		},
		[applicantIsOnlyUser, agreementProcessId, config, http, user, t, goToNextPage]
	);

	useEffect(() => {
		if (data?.hasOnlineBankingAccount) {
			goToNextPage();
		}
	}, [data]); // eslint-disable-line

	return {
		...ctx,
		applicantIsOnlyUser,
		errors,
		goToNextPage,
		navigate,
		setApplicantIsOnlyUser,
		submitForm,
		validate
	};
}
